import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';
import { IdSchema } from '../../../resource-base/baseSchemas';

export enum ProcessAreaRoleAssociationPropertyValidation {
    ROLE = 'ROLE',
    ROLE_RELATION = 'ROLE_RELATION',
}

export const ProcessAreaRoleAssociationResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z
        .literal(ResourceType.PROCESS_AREA_ROLE_ASSOCIATION)
        .default(ResourceType.PROCESS_AREA_ROLE_ASSOCIATION),
    role: IdSchema,
    roleRelation: IdSchema.nullable(),
});
export const ProcessAreaRoleAssociationMutationResourceSchema = getMutationSchema(
    ProcessAreaRoleAssociationResourceSchema
);

export type ProcessAreaRoleAssociationResource = z.infer<typeof ProcessAreaRoleAssociationResourceSchema>;

export const defaultProcessAreaRoleAssociationResource: ProcessAreaRoleAssociationResource = {
    ...defaultIndirectlyVersionedArtifactResource,
    resourceType: ResourceType.PROCESS_AREA_ROLE_ASSOCIATION,
    role: '',
    roleRelation: null,
};

export function useProcessAreaRoleAssociationActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/process-area-role-association',
            ResourceType.PROCESS_AREA_ROLE_ASSOCIATION,
            ProcessAreaRoleAssociationResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/process-area-role-association',
            ResourceType.PROCESS_AREA_ROLE_ASSOCIATION,
            ProcessAreaRoleAssociationResourceSchema
        ),
    };
}
